import React, { useState, useEffect, useMemo } from 'react';
import moment from 'moment';
import {
  useParams,
  NavLink,
} from 'react-router-dom';

import meta from '../../config/meta.js';
import env from '../../config/env.js';

import Header from '../layout/Header.jsx';
import SearchAssignments from '../blocks/SearchAssignments.jsx';
import ReadingMissions from '../blocks/ReadingMissions.jsx';
import Tabs from '../layout/Tabs.jsx';
import useQuery from '~/commons/hooks/useQuery';
import useHttpStatus from '~/commons/hooks/useHttpStatus';
import ReadingList from './ReadingList.jsx';

const PageReadingMissionsList = () => {
  const { assignmentId } = useParams();
  const [assignmentsRes, assignmentsReq, fetched = { total: 0 }] = useHttpStatus();
  const { q = '', answered: answeredQ = '0' } = useQuery();
  const [filter, setFilter] = useState({
    answered: parseInt(answeredQ, 10),
    from: '',
    to: moment().format('YYYY-MM-DD'),
    article: {
      search: q,
      subjects: [],
      tags: [],
    },
  });
  const { answered } = filter;

  meta.set({ title: '文章庫' });

  useEffect(() => {
    setFilter({
      ...filter,
      article: { ...filter.article, search: q },
    });
  }, [q]);

  useEffect(() => {
    assignmentsReq({
      url: '/api/quiz/assignments',
      params: {
        sort: { createdAt: 1 },
        noArticles: true,
      },
    });
  }, []);
  return (
    <div>
      <header
        className="d-flex position-relative justify-content-center align-items-center -min-vh-30"
        style={{
          height: '180px',
          background: 'linear-gradient(180deg, #4EB2FF 0%, #169CFD 100%)',
        }}
      >
        <div className="container-fluid overflow-hidden">
          <div className="row justify-content-center align-items-center">
            <div className="col text-left">
              <div className="row justify-content-center align-items-end">
                <div className="col col-auto">
                  <img src="/assets/img/mission-reading-header-left.png" height="180"/>
                </div>
                <div className="col d-none d-md-flex justify-content-center">
                  <img src="/assets/img/boy.png" className="px-2 pb-3" height="149"/>
                  <img src="/assets/img/girl.png" className="px-2 pt-3" height="148"/>
                </div>
              </div>
            </div>
            <div className="col col-auto">
              <img src="/assets/img/mission-reading.png"/>
            </div>
            <div className="col text-right">
              <img src="/assets/img/mission-reading-header-right.png" height="180"/>
            </div>
          </div>
        </div>
      </header>
      <ReadingList assignmentId={assignmentId} />
    </div>
  );
};

export default PageReadingMissionsList;
